export default {
  debug: false,
  api: [{
    version: '',
    chemin_api: '',
    // service: 'KYC',
    //  protocole: 'https',
    // host: 'api.dealprudence.rtp.streammind.com',
    // port: '443',
    protocole: 'A',
    host: 'A',
    port: 'A',
    address: function () {
      return this.protocole +
      '://' +
      this.host +
      (this.port !== '' ? ':' + this.port : '') +
      '/' +
      (this.version !== '' ? this.version + '/' : '')
    }
  }],
  crypto: {
    secret: 'streammind'
  },
  language: 'fr',
  visual: 'SAAS',
  faq: {
    userguide: 'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/EPC112-25 v1.2 VOP ART User Guide.pdf',
    testcaselist: 'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/EPC139-25 v1.1 VOP API Reference Toolbox - Test Cases.pdf',
    onboardingguide: 'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/EPC151-25 v1.1 VOP ART User Self-Registration Guide.pdf',
    videoSettingID: 'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/Toolbox_Training_Setting_id_types.mp4',
    videoresponderconf: 'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/Toolbox_Training_Responder_settings.mp4',
    videotestsession: 'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/Toolbox_Training_Test_Session.mp4',
    videoresponderconf1: 'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/Toolbox_Training_Requester_setup_with_certificate_generation.mp4',
    videoresponderconf2: 'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/Toolbox_Training_Requester_setup_using_a_preexisting_certificate.mp4',
    videoFAQ: 'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/Toolbox_Training_FAQ.mp4',
    videoResponderTesCase: 'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/Toolbox_Training_Responder_test_case.mp4',
    videoRequesterTestCase:'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/Toolbox_Training_Requester_test_case.mp4',
    videoWiewRequests:'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/Toolbox_Training_View_requests.mp4',
    videoTestReport: 'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/Toolbox_Training_Test_report.mp4',
    requestertestdataimportexemple: 'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/TestData_Requester_Import.csv',
    respondertestdataimportexemple: 'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/TestData_Responder_Import.csv',
    voprequestbicexemple: 'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/VOP_Request_BIC_Template.json',
    voprequestidexemple: 'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/VOP_Request_Id_Template.json',
    voprequestleiexemple: 'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/VOP_Request_LEI_Template.json',
    voprequestnameexemple: 'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/VOP_Request_Name_Template.json'
  },
  rgpd: {
    rgpd_mandatory: 'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/Data policy Toolbox.16052025.pdf',
    conditions_mandatory: 'https://cdn1.streammind.com/cdnepc/prd_D1TCYQD/Terms and Conditions ART Plateform.23062025.pdf'
  },
  apientry: {
    host_apientry: 'https://epcapi.toolbox.dev.cloud.streammind.com/vop/v1/payee-verifications',
    port_apientry: '443'
  }
}
